import { ChevronsUp, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEVERITY_LABELS } from '@momentum/types';

interface SeverityBadgeProps {
  severity: number;
}

export const SeverityBadge = ({ severity }: SeverityBadgeProps) => {
  const { t } = useTranslation('knowledge');

  if (severity >= SEVERITY_LABELS.Critical) {
    return (
      <span className="inline-flex items-center gap-1 rounded-md border border-red-200 bg-red-50 px-2 py-0.5 text-[11px] font-semibold text-red-700">
        <ChevronsUp className="h-3 w-3" />
        {t('severityCritical')}
      </span>
    );
  }

  if (severity >= SEVERITY_LABELS.High) {
    return (
      <span className="inline-flex items-center gap-1 rounded-md border border-orange-200 bg-orange-50 px-2 py-0.5 text-[11px] font-semibold text-orange-700">
        <ChevronUp className="h-3 w-3" />
        {t('severityHigh')}
      </span>
    );
  }

  return null;
};
